import { useRouter } from "next/router";
import {
  IFSecureOffer,
  IFtthOffer,
  IMobileOffer,
  IOfferMode,
  IOfferModeWithFSecure,
  IStaticOffer,
} from "./fetchProductOffers/types";

export function isMobileOffer(
  offer: IStaticOffer | undefined,
): offer is IMobileOffer {
  if (!offer) {
    return false;
  }

  return ["MOBILE_POSTPAID", "MOBILE"].includes(offer.category);
}

export function isFtthOffer(
  offer: IStaticOffer | undefined,
): offer is IFtthOffer {
  if (!offer) {
    return false;
  }

  return offer.category === "FTTH";
}

export function isFsecureOffer(
  offer: IStaticOffer | undefined,
): offer is IFSecureOffer {
  if (!offer) {
    return false;
  }

  return offer.category === "FSECURE";
}

export function useOfferMode(): IOfferMode {
  const router = useRouter();
  const { mode } = router.query;

  if (mode === "mobile") {
    return "mobile";
  }

  if (mode === "postpaid") {
    return "postpaid";
  }

  return "ftth";
}

export function useOfferModeWithFsecure(): IOfferModeWithFSecure {
  const router = useRouter();
  const { mode } = router.query;

  return mode === "mobile" ||
    mode === "postpaid" ||
    mode === "ftth" ||
    mode === "fsecure"
    ? mode
    : "fsecure";
}

export function useOfferModeWithoutFallback(): IOfferMode | undefined {
  const router = useRouter();
  const { mode } = router.query;

  if (mode === "mobile") {
    return "mobile";
  }

  if (mode === "ftth") {
    return "ftth";
  }

  return undefined;
}

export function useOfferModeWithFsecureWithoutFallback():
  | IOfferModeWithFSecure
  | undefined {
  const router = useRouter();
  const { mode } = router.query;

  if (mode === "mobile") {
    return "mobile";
  }

  if (mode === "postpaid") {
    return "postpaid";
  }

  if (mode === "ftth") {
    return "ftth";
  }

  if (mode === "fsecure") {
    return "fsecure";
  }

  return undefined;
}

export function modeToWord(mode?: IOfferModeWithFSecure): string {
  if (mode === "mobile") {
    return "mobile";
  }
  if (mode === "ftth") {
    return "światłowód";
  }
  return "subskrypcja";
}
